export default {
  seeMoreMargin: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin',
    defaultMessage: 'See more margin',
  },
  marginCostIncludesTitle: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-cost-includes-title',
    defaultMessage: 'All Back Market-related costs included:',
  },
  marginCostIncludesItem1: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-cost-includes-item-1',
    defaultMessage: 'CCBM fee',
  },
  marginCostIncludesItem2: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-cost-includes-item-2',
    defaultMessage: 'Installment fee',
  },
  marginCostIncludesItem3: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-cost-includes-item-3',
    defaultMessage: 'Logistics fee',
  },
  marginCostIncludesItem4: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-cost-includes-item-4',
    defaultMessage: 'Sales & Trade-in commissions',
  },
  customizationCostTitle: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-customization-cost-title',
    defaultMessage: 'Customization cost:',
  },
  customizationCostValue: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-customization-cost-value',
    defaultMessage: 'Based on your account peformance & quality',
  },
  resellingPriceTitle: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-reselling-price-title',
    defaultMessage: 'Reselling price',
  },
  resellingPriceValue: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-reselling-price-value',
    defaultMessage:
      'It is the average device price in Good condition over the last 15 days on Back Market.',
  },
  lastDays: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-last-days',
    defaultMessage: 'Last 15 days',
  },
  lastDaysValue: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-last-days-value',
    defaultMessage: 'For an up-to-date price',
  },
  condition: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-condition',
    defaultMessage: 'Good condition',
  },
  conditionValue: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-condition-value',
    defaultMessage:
      'In the grade that you are most likely to sell back the device in Back Market',
  },
  seeMoreMarginInfoBlockTitle: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-info-block-title',
    defaultMessage: 'Not included: ',
  },
  seeMoreMarginInfoBlockContent1: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-info-block-content-1',
    defaultMessage: 'Your repair costs (if any)',
  },
  seeMoreMarginInfoBlockContent2: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-info-block-content-2',
    defaultMessage: 'Your internal operational costs',
  },
  seeMoreMarginInfoBlockContent3: {
    id: 'bo_sellers-buyback-opportunities-modal-see-more-margin-info-block-content-3',
    defaultMessage: 'VAT related costs (EU only)',
  },
}
